import styled from '@emotion/styled';
import useAppCustom from '@hooks/useAppCustom';
import CouponIcon from '@icons/CouponIcon';
import EventIcon from '@icons/EventIcon';
import HomeLineIcon from '@icons/HomeLineIcon';
import MapIcon from '@icons/MapIcon';
import OrderIcon from '@icons/OrderIcon';
import PointIcon from '@icons/PointIcon';
import PrepaidCardIcon from '@icons/PrepaidCardIcon';
import StampIcon from '@icons/StampIcon';
import { NavigationItem } from '@models/custom';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import NavItem from './NavItem';

function NavigationBar() {
    const { navigationItems } = useAppCustom().main;
    const { t } = useTranslation('main', { keyPrefix: 'navigation' });
    return (
        <Container>
            <NavItem label={t('main')}
                isCurrent
                activityParams={{}}
                icon={HomeLineIcon}/>
            {navigationItems?.map((item, index) => makeMenu(
                item,
                index === 1 && navigationItems.length >= 4,
                t,
            ))}
        </Container>
    );
}

const Container = styled.nav`
    background-color: var(--color-white);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.14);
    display: flex;
    padding: 4px 0  calc(4px + var(--safe-area-bottom));
    width: 100%;
`;

function makeMenu(
    navigationItem: NavigationItem,
    isCenter: boolean,
    t: TFunction,
) {
    switch (navigationItem) {
    case 'PREPAID_CARD':
        return <NavItem label={t('prepaidCard')}
            useGuard
            isCenter={isCenter}
            activityName='MyPrepaidCardActivity'
            activityParams={{}}
            icon={PrepaidCardIcon}/>;
    case 'SHOP':
        return <NavItem label={t('findShop')}
            isCenter={isCenter}
            key={navigationItem}
            activityName='ShopListActivity'
            activityParams={{ isOrder: false, type: 'LIST' }}
            icon={MapIcon}/>;
    case 'EVENT':
        return <NavItem label={t('event')}
            isCenter={isCenter}
            key={navigationItem}
            activityName='BoardActivity'
            activityParams={{ type: 'EVENT' }}
            icon={EventIcon}/>;
    case 'COUPON':
        return <NavItem label={t('coupon')}
            useGuard
            isCenter={isCenter}
            activityName='CouponActivity'
            activityParams={{ type: 'MY' }}
            icon={CouponIcon}/>;
    case 'POINT':
        return <NavItem label={t('point')}
            useGuard
            isCenter={isCenter}
            activityName='PointActivity'
            activityParams={{}}
            icon={PointIcon}/>;
    case 'STAMP':
        return <NavItem label={t('stamp')}
            useGuard
            isCenter={isCenter}
            activityName='StampsActivity'
            activityParams={{}}
            icon={StampIcon}/>;
    case 'GIFT':
        return <NavItem label={t('gift')}
            useGuard
            isCenter={isCenter}
            activityName='GiftsActivity'
            activityParams={{ type: 'MAIN' }}
            icon={StampIcon}/>;
    case 'ORDER':
        return (
            <NavItem label={t('order')}
                isCenter={isCenter}
                activityName='ShopListActivity'
                activityParams={{ isOrder: true, type: 'LIST' }}
                icon={OrderIcon}/>
        );
    default:
        throw new Error('Unknown navigation item');
    }
}

export default NavigationBar;
